(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/payfooter-react.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/payfooter-react.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _svs$tur$ReactPayfoot = svs.tur.ReactPayfooter,
  Sum = _svs$tur$ReactPayfoot.Sum,
  Balance = _svs$tur$ReactPayfoot.Balance,
  ButtonList = _svs$tur$ReactPayfoot.ButtonList,
  TextList = _svs$tur$ReactPayfoot.TextList,
  LegalInfo = _svs$tur$ReactPayfoot.LegalInfo;
const reminder = new svs.tur.payfooter_reminder();
const Payfooter = _ref => {
  let _ref$isBottom = _ref.isBottom,
    isBottom = _ref$isBottom === void 0 ? true : _ref$isBottom,
    sum = _ref.sum,
    _ref$isShowingSum = _ref.isShowingSum,
    isShowingSum = _ref$isShowingSum === void 0 ? true : _ref$isShowingSum,
    balance = _ref.balance,
    balanceLabel = _ref.balanceLabel,
    children = _ref.children,
    buttons = _ref.buttons,
    texts = _ref.texts,
    _ref$hasReminder = _ref.hasReminder,
    hasReminder = _ref$hasReminder === void 0 ? true : _ref$hasReminder,
    _ref$hasLeaveReminder = _ref.hasLeaveReminder,
    hasLeaveReminder = _ref$hasLeaveReminder === void 0 ? true : _ref$hasLeaveReminder,
    isLegalInfo = _ref.isLegalInfo,
    _ref$isFixed = _ref.isFixed,
    isFixed = _ref$isFixed === void 0 ? false : _ref$isFixed,
    reminderTrackingLabel = _ref.reminderTrackingLabel,
    _ref$topContent = _ref.topContent,
    topContent = _ref$topContent === void 0 ? null : _ref$topContent;
  const element = React.createRef();
  const pseudoFiller = React.createRef(); 
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inViewPort = _React$useState2[0],
    setInViewPort = _React$useState2[1];
  const _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isSeen = _React$useState4[0],
    setIsSeen = _React$useState4[1];
  reminder.updateTrackingLabel(reminderTrackingLabel);
  React.useEffect(() => {
    if (!isFixed) {
      const observer = new IntersectionObserver(entries => {
        if (entries && entries[0]) {
          setInViewPort(entries[0].isIntersecting);
        }
      });
      observer.observe(element.current);
      if (isBottom && inViewPort) {
        gsap.from(element.current, {
          duration: 0.2,
          y: '100%'
        });
      }
      return () => {
        observer.disconnect();
        reminder.removeDomElements();
      };
    }
  }, []);
  React.useEffect(() => {
    let timeout;
    if (isFixed) {
      pseudoFiller.current.style.height = "".concat(element.current.clientHeight, "px");
    } else if (hasReminder && !isSeen) {
      if (!inViewPort) {
        reminder.show(null, hasLeaveReminder);
      } else {
        timeout = setTimeout(() => {
          setIsSeen(true);
        }, 1000);
      }
    }
    return () => {
      clearTimeout(timeout);
    };

  }, [balance, hasReminder, sum, inViewPort]);
  return React.createElement(React.Fragment, null, isFixed && React.createElement("div", {
    ref: pseudoFiller
  }), React.createElement("div", {
    className: "payfooter payfooter-default dots ".concat(isFixed ? 'payfooter-fixed' : '', " dots-tur ").concat(isBottom ? 'payfooter-block' : ''),
    ref: element
  }, React.createElement("div", {
    className: "payfooter-inner"
  }, topContent, React.createElement(Balance, {
    label: balanceLabel,
    value: balance
  }), isShowingSum && React.createElement(Sum, {
    value: sum
  }), React.createElement(ButtonList, {
    buttonOptions: buttons,
    sum: sum
  }), React.createElement(TextList, {
    textOptions: texts
  }), isLegalInfo && React.createElement(LegalInfo, null), React.createElement("div", null, children))));
};
svs.tur.ReactPayfooter.Payfooter = Payfooter;

 })(window);